/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineBookingGuestSexKindDto } from './traveline-booking-guest-sex-kind-dto';
import {
    TravelineBookingGuestSexKindDtoFromJSON,
    TravelineBookingGuestSexKindDtoFromJSONTyped,
    TravelineBookingGuestSexKindDtoToJSON,
    TravelineBookingGuestSexKindDtoToJSONTyped,
} from './traveline-booking-guest-sex-kind-dto';

/**
 * Guest entity
 * @export
 * @interface TravelineBookingGuestDto
 */
export interface TravelineBookingGuestDto {
    /**
     * Name
     * @type {string}
     * @memberof TravelineBookingGuestDto
     */
    firstName: string;
    /**
     * Surname
     * @type {string}
     * @memberof TravelineBookingGuestDto
     */
    lastName: string;
    /**
     * Second name
     * @type {string}
     * @memberof TravelineBookingGuestDto
     */
    middleName?: string | null;
    /**
     * Country.<br />
     * Three-letter code compliant with ISO 3166-1 alpha-3
     * @type {string}
     * @memberof TravelineBookingGuestDto
     */
    citizenship?: string | null;
    /**
     * 
     * @type {TravelineBookingGuestSexKindDto}
     * @memberof TravelineBookingGuestDto
     */
    sex?: TravelineBookingGuestSexKindDto;
}



/**
 * Check if a given object implements the TravelineBookingGuestDto interface.
 */
export function instanceOfTravelineBookingGuestDto(value: object): value is TravelineBookingGuestDto {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function TravelineBookingGuestDtoFromJSON(json: any): TravelineBookingGuestDto {
    return TravelineBookingGuestDtoFromJSONTyped(json, false);
}

export function TravelineBookingGuestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingGuestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'citizenship': json['citizenship'] == null ? undefined : json['citizenship'],
        'sex': json['sex'] == null ? undefined : TravelineBookingGuestSexKindDtoFromJSON(json['sex']),
    };
}

  export function TravelineBookingGuestDtoToJSON(json: any): TravelineBookingGuestDto {
      return TravelineBookingGuestDtoToJSONTyped(json, false);
  }

  export function TravelineBookingGuestDtoToJSONTyped(value?: TravelineBookingGuestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'middleName': value['middleName'],
        'citizenship': value['citizenship'],
        'sex': TravelineBookingGuestSexKindDtoToJSON(value['sex']),
    };
}

